import { Typography } from "@mui/material";

export const NotFound: React.FC = () => {
    return <Typography>page not found</Typography>;
};
